<section class="workspace-page workspace-page--full">
  <header class="workspace-collection-header">
    <h1 class="workspace-page__title">Lead Discovery</h1>
  </header>
  <div class="prospect-controls">
    <app-prospect-control (pullStarted)="activity.showJob($event)"></app-prospect-control>
  </div>
  <app-pull-activity #activity></app-pull-activity>
</section>
